import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

import Swiper from 'swiper/bundle'; // import Swiper JS ALL

/*
 * word: ®︎ に supタグを追加
*/
document.addEventListener('DOMContentLoaded', function () {
  // 一旦全てのマーカーを消す:
  unmarkText(document.querySelector("body"));
  const word = '®︎';
  // マーカーを引く:
  const items = document.querySelectorAll("body");
  for (let len = items.length, i = 0; i < len; i++) {
    const item = items[i];
    markText(item, word);
  }
});

/**
 * マッチテキストにマーカーを引く(markタグを付与)
 * @param {HTMLElement} node - 親要素
 * @param {String} word - 検索文字列
 *  空文字列をセットするとマーカーが除去されます。
 */
function markText(node, word) {
  if (node instanceof HTMLElement !== true) {
    return console.warn("markText: node must be an HTMLElement");
  }
  if (!word || typeof word !== "string") return;
  _markText(node, new RegExp(word, "g"), function(node, match, offset) {
    const mark = document.createElement("sup");
    // mark.className = "search-term";
    mark.textContent = match;
    return mark;
  });

  // @see: https://stackoverflow.com/a/29301739
  function _markText(node, regex, callback, excludeElements) {
    excludeElements || (excludeElements = ['script', 'style', 'iframe', 'canvas']);
    let child = node.firstChild;
    while (child) {
      switch (child.nodeType) {
        case 1:
          {
            if (excludeElements.indexOf(child.tagName.toLowerCase()) > -1)
              break;
            _markText(child, regex, callback, excludeElements);
            break;
          }
        case 3:
          {
            let bk = 0;
            child.data.replace(regex, function(all) {
              let args = [].slice.call(arguments),
                offset = args[args.length - 2],
                newTextNode = child.splitText(offset + bk),
                tag;
              bk -= child.data.length + all.length;
              newTextNode.data = newTextNode.data.substr(all.length);
              tag = callback.apply(window, [child].concat(args));
              child.parentNode.insertBefore(tag, newTextNode);
              child = newTextNode;
            });
            regex.lastIndex = 0;
            break;
          }
      }
      child = child.nextSibling;
    }
    return node;
  }
}
/**
 * 指定された要素からマーカーを除去(markタグを外す)
 * @param {HTMLElement} node - ノード
 */
function unmarkText(node) {
  if (node instanceof HTMLElement !== true) {
    console.warn("unmarkText: node must be an HTMLElement.");
    return;
  }
  const items = node.querySelectorAll("sup");
  for (let len = items.length, i = 0; i < len; i++) {
    const node = items[i];
    if (node.nodeName === "SUP" || node.nodeName === "sup") {
      const pn = node.parentNode;
      _unmarkText(node);
      // NOTE: タグの付与でバラけてしまったTextNodeをまとめたりする:
      pn.normalize();
    }
  }

  function _unmarkText(node) {
    const txtn = document.createTextNode(node.textContent);
    node.parentNode.replaceChild(txtn, node);
  }
}


/*
 * Home
*/

// Home - Hero
const homeSwiper = new Swiper('#home-hero-swiper', {
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  /*
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
  */
});


/*
 * Home - We do
 */

/*
$(window).on('load resize',function(){
  var pos01 = 120;
  var pos02 = Math.round($("#wedo02").offset().top);
  var pos03 = Math.round($("#wedo03").offset().top);
  var pos04 = Math.round($("#wedo04").offset().top);

  console.log('1:'+pos01);
  console.log('2:'+pos02);
  console.log('3:'+pos03);
  console.log('4:'+pos04);

  $(window).on('load resize scroll',function(){
    var posScroll = $(window).scrollTop();
    console.log(posScroll);
    if(pos01 <= posScroll && posScroll < pos02) {
      $("#wedo-outline01").addClass('current').siblings('li').removeClass('current');
      $("#wedo01").addClass('current');
    } else if(pos02 <= posScroll && posScroll < pos03) {
      $("#wedo-outline02").addClass('current').siblings('li').removeClass('current');
      $("#wedo02").addClass('current');
    } else if(pos03 <= posScroll && posScroll < pos04) {
      $("#wedo-outline03").addClass('current').siblings('li').removeClass('current');
      $("#wedo03").addClass('current');
    } else if(pos04 <= posScroll && posScroll) {
      $("#wedo-outline04").addClass('current').siblings('li').removeClass('current');
      $("#wedo04").addClass('current');
    }
  });
});
*/

/* IntersectionObserver */
document.addEventListener('DOMContentLoaded', function () {
  /* WEDO */
  const detail = new ScrollWedo('.pc .wedo-detail');
  const outline = new ScrollWedoMobile('.mobile .wedo-outline');

  /* getintouch */
  const getintouch = new ScrollGetintouch('#getintouch');
});

/*
// 幅が768px以下のビューポートをターゲットとする条件を作成
const mediaQuery = window.matchMedia('(max-width: 768px)')
 
function handleTabletChange(e) {
  // メディアクエリがtrueかどうかを確認
  if (e.matches) {
    // mobile
    document.removeEventListener('DOMContentLoaded');
  } else {
    // pc
  }
}
// イベントリスナーを登録
mediaQuery.addListener(handleTabletChange);
// 初期チェック
handleTabletChange(mediaQuery);
*/

class ScrollWedo {
  constructor(el, callback, options) {
    this._addOptions(options);
    this._addCallback(callback);
    const observer = new IntersectionObserver(this.callback, this.options);
    const els = document.querySelectorAll(el);
    els.forEach( el => observer.observe(el));
  }

  _addOptions(options) {
    this.options = Object.assign({
      root: null,
      rootMargin: "-50% 0px",
      threshold: 0
      // threshold: [0.25, 0.5]
    }, options);
  }
  _addCallback(callback) {
    if (callback) {
      this.callback = callback;
    } else {
      this.callback = (entries, observer) => {
        entries.forEach( entry => {
          if(entry.isIntersecting) {
            entry.target.classList.add('current');
            // observer.unobserve(entry.target);
            $('.wedo-outline').removeClass('current');
            $('.wedo-outline[data-num="'+entry.target.dataset.num+'"]').addClass('current');
          } else {
            // $('.wedo-outline').removeClass('current');
            entry.target.classList.remove('current');
          }
        });
      };
    }
  }
}
class ScrollWedoMobile {
  constructor(el, callback, options) {
    this._addOptions(options);
    this._addCallback(callback);
    const observer = new IntersectionObserver(this.callback, this.options);
    const els = document.querySelectorAll(el);
    els.forEach( el => observer.observe(el));
  }

  _addOptions(options) {
    this.options = Object.assign({
      root: null,
      rootMargin: "-50% 0px",
      threshold: 0
      // threshold: [0.25, 0.5]
    }, options);
  }
  _addCallback(callback) {
    if (callback) {
      this.callback = callback;
    } else {
      this.callback = (entries, observer) => {
        entries.forEach( entry => {
          if(entry.isIntersecting) {
            entry.target.classList.add('current');
          } else {
            entry.target.classList.remove('current');
          }
        });
      };
    }
  }
}



/*
 * Single product
 */
$(function() {
  //swiper 768以下で起動
  var swiper;
  $(window).on('load resize', function(){
    var w = $(window).width();
    if (w <= 767.98) {
      if (swiper) {
        return;
      } else {
        swiper = new Swiper('#single-product-gallery', {
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });
      }
    } else {
      if (swiper) {
        swiper.destroy();
        swiper = undefined;
      }
    }
  });
});

const SingleProductSubgallerySwiper = new Swiper('#single-product-subgallery', {
  slidesPerView: "auto",
  spaceBetween: 18,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    991: {
      slidesPerView: "auto",
      spaceBetween: 48,
    }
  }
});



/*
 * Project
 */
const projectSwiper = new Swiper('#project-swiper', {
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: true,
  },
  mousewheel: true,
  // freeMode: true,
  slidesPerView: 'auto',
  spaceBetween: 30,
  breakpoints: {
    768: {
      spaceBetween: 60,
    }
  }
});

const customGallerySwiper = new Swiper('.customgallery-swiper .swiper-container', {
  scrollbar: {
    el: ".swiper-scrollbar",
    // hide: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  spaceBetween: 18,
  centeredSlides: false,
  autoHeight: true,
  slidesPerView: 1,

  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 48,
    }
  }
});



/*
 * Get in touch
 */
$('header .container-fluid').clone().appendTo('#getintouch #header');

class ScrollGetintouch {
  constructor(el, callback, options) {
    this._addOptions(options);
    this._addCallback(callback);
    const observer = new IntersectionObserver(this.callback, this.options);
    const els = document.querySelectorAll(el);
    els.forEach( el => observer.observe(el));
  }

  _addOptions(options) {
    this.options = Object.assign({
      root: null,
      rootMargin: "-50% 0px",
      threshold: 0
      // threshold: [0.25, 0.5]
    }, options);
  }
  _addCallback(callback) {
    if (callback) {
      this.callback = callback;
    } else {
      this.callback = (entries, observer) => {
        entries.forEach( entry => {
          if(entry.isIntersecting) {
            entry.target.classList.add('show');
          } else {
            entry.target.classList.remove('show');
          }
        });
      };
    }
  }
}



/*
 * Cursor
*/
// マウスストーカー要素
var mouseStalker

// マウスストーカー要素の位置
var stalker = {
  x: 0,
  y: 0
}

// マウスの位置
var mouse = {
  x: 0,
  y: 0
}

// DOM の解析後に初期化をするためのハンドラ
document.addEventListener('DOMContentLoaded', setup)

// マウスの動きを監視
document.addEventListener('mousemove', mousemove)

// 初期化処理
function setup() {
  // マウスストーカー要素を取得
  mouseStalker = document.querySelector('.mouse-stalker')

  // 更新処理を開始
  update()
}

// マウスが動くたびにマウスの位置を保持しておく
function mousemove(e) {
  mouse.x = e.clientX
  mouse.y = e.clientY
}

// 更新処理
function update() {
  // マウスストーカー要素の位置を更新
  stalker.x += (mouse.x - stalker.x) * 0.2 // Speed: 0.2
  stalker.y += (mouse.y - stalker.y) * 0.2 // Speed: 0.2

  // マウスストーカーの位置を小数点第一位まで四捨五入
  var x = Math.round(stalker.x * 10) / 10
  var y = Math.round(stalker.y * 10) / 10

  // マウスストーカー要素のスタイルを更新
  mouseStalker.style.transform = `translate3d(` + x + 'px,' + y + 'px, 0)'

  // ループ
  requestAnimationFrame(update)
}

$("a, button").on({
  "mouseenter": function() {
    mouseStalker.classList.add("hover");
  },
  "mouseleave": function() {
    mouseStalker.classList.remove("hover");
  }
});



/*
 * Parallax
*/
function parallax(elem,speed,number){
  var target = document.getElementsByClassName(elem)[number];
  var scroll_value = window.pageYOffset;
  if(scroll_value <= 768){
    target.style.transform = 'translateY('+(scroll_value/speed)+'px)';
  } else {
    // return;
  }
}

const el = document.querySelector("parallax");
if(el != null) {
}
window.addEventListener('scroll',function(){
  parallax('parallax',2,0);
});


/*
 * Skew Scrolling Effect
*/
/*
const section = document.querySelector('.skew-scrolling');
let currentPos = window.pageYOffset;
const Supdate = () => {
	const newPos = window.pageYOffset;
	const diff = newPos - currentPos;
	const speed = diff * 0.35;
  section.style.transform = 'skewY('+speed+'deg)';
  // section.style.transform = 'skewY(1deg)';
	currentPos = newPos;
	requestAnimationFrame(Supdate);
}
Supdate();
*/


















/*
 * Three

import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js';
*/
